module.exports = __webpack_public_path__ + "img/ZABAY.85fdfde7.png";